var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentDirectGalleryOneProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48562 11.0148C8.84018 11.0148 9.93827 9.86418 9.93827 8.44488C9.93827 7.02557 8.84018 5.875 7.48562 5.875C6.13105 5.875 5.03296 7.02557 5.03296 8.44488C5.03296 9.86418 6.13105 11.0148 7.48562 11.0148Z",
    stroke: "#404041",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92495 13.8445H1.69995C1.14767 13.8445 0.699951 13.3968 0.699951 12.8445V5.78499C0.699951 5.2327 1.14767 4.78499 1.69995 4.78499H3.46873C3.85434 4.78499 4.2056 4.56327 4.37148 4.21515L4.99167 2.91359C5.15755 2.56547 5.5088 2.34375 5.89442 2.34375H8.87823C9.24441 2.34375 9.5813 2.54389 9.75644 2.86547L10.5177 4.26327C10.6928 4.58485 11.0297 4.78499 11.3959 4.78499H13.2574C13.8097 4.78499 14.2575 5.2327 14.2575 5.78499V8.4375",
    stroke: "#404041",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58643 12.4564L15.4034 9.53906L14.2104 16.0278L8.58643 12.4564Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4035 9.55859L10.7168 14.0228",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7166 14.0234V16.2556L11.9947 14.9163",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8325 16.5466V17.6195C11.8325 17.8254 11.9588 18.0103 12.1506 18.0852L15.7661 19.4977C15.9099 19.5539 16.0715 19.5405 16.204 19.4615L19.3879 17.5645C19.5392 17.4743 19.6319 17.3112 19.6319 17.135V13.7104C19.6319 13.4975 19.4971 13.3079 19.296 13.2381L15.7322 12",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.8008L15.9229 14.9773",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3719 13.3477L15.9922 14.9734V19.5796",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDirectGalleryOneProvider);
export default __webpack_public_path__ + "static/media/ContentDirectGalleryOneProvider.aa0da808e68a38642b65654411911157.svg";
export { ForwardRef as ReactComponent };